import { useState } from "react";
import { MessageSquare } from "lucide-react";
import dynamic from "next/dynamic";

const FeedbackModal = dynamic(() => import("./FeedbackModal"), { ssr: false });

/**
 * Inline "Improve this tool" link for feature modules.
 * Pass featureContext to identify which tool the feedback is about.
 */
export default function FeatureFeedbackLink({
  featureContext,
  label = "Improve this tool",
}: {
  featureContext: string;
  label?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 text-xs text-slate-400 transition-colors hover:text-primary-600 dark:hover:text-primary-400"
      >
        <MessageSquare className="h-3 w-3" />
        {label}
      </button>
      <FeedbackModal isOpen={open} onClose={() => setOpen(false)} featureContext={featureContext} />
    </>
  );
}
